import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ellip-fill",
  "use": "icon-ellip-fill-usage",
  "viewBox": "0 0 160 160",
  "content": "<symbol viewBox=\"0 0 160 160\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-ellip-fill\">\n   \n  \n        <ellipse id=\"icon-ellip-fill_Oval\" cx=\"80\" cy=\"82\" rx=\"71\" ry=\"48\" />\n   \n</symbol>"
});
var result = sprite.add(symbol);
export default symbol